export default __webpack_public_path__ + "static/cta-arrow-9820157f0b08aa92e5e66f58b91045c4.png";